module.exports = __webpack_public_path__ + "static/media/one_button_cut.a19c1aaf.svg";